import { Box, Typography } from '@mui/material';
import { JSX } from 'react';
import Content from '../content';

const LayoutFooter = (): JSX.Element => (
  <Box className="border-t mt-8 py-8 text-center">
    <Content className="space-y-4">
      <Box className="flex flex-col md:flex-row md:space-x-4 items-center justify-center">
        <a
          href="https://www.momentum.co.za/momentum/support/legal-and-compliance"
          className="border-b"
        >
          <Typography color="primary">Legal and Compliance</Typography>
        </a>
        <a
          href="https://www.momentum.co.za/momentum/support/security-and-fraud"
          className="border-b"
        >
          <Typography color="primary">Security and Fraud</Typography>
        </a>
        <a
          href="https://www.momentum.co.za/momentum/support/terms-and-conditions"
          className="border-b"
        >
          <Typography color="primary">Terms and Conditions</Typography>
        </a>
        <a href="https://www.momentum.co.za/momentum/support/privacy-policy" className="border-b">
          <Typography color="primary">Privacy policy</Typography>
        </a>
      </Box>
      <Typography className="text-[#3D3D3D]">
        Momentum is part of Momentum Metropolitan Life Limited, an authorised financial services and
        registered credit provider. ©2023 Momentum Metropolitan Life Limited.
      </Typography>
    </Content>
  </Box>
);

export default LayoutFooter;
